import { Injectable } from '@angular/core';
import { ToastyService, ToastData, ToastOptions } from 'ng2-toasty';

@Injectable()
export class NotificationsService {
  position: string = 'bottom-right';
  title: string;
  msg: string;
  showClose: boolean = true;
  timeout: number = 5000;
  theme: string = 'bootstrap';
  type: string = 'default';
  closeOther: boolean = false;
  constructor(private toastyService: ToastyService) { }

  addToast(message: string, titre?: string, type?: string) {
    const options = {
      title: titre,
      msg: message,
      showClose: true,
      timeout: 5000,
      theme: 'bootstrap',
      type: type ? type : 'wait',
      position: 'top-left',
      closeOther: true };

    if (options.closeOther) {
      this.toastyService.clearAll();
    }
    this.position = options.position ? options.position : this.position;
    const toastOptions: ToastOptions = {
      title: options.title,
      msg: options.msg,
      showClose: options.showClose,
      timeout: options.timeout,
      theme: options.theme,
      onAdd: (toast: ToastData) => {
        console.log('Toast ' + toast.id + ' has been added!');
      },
      onRemove: (toast: ToastData) => {
        console.log('Toast ' + toast.id + ' has been added removed!');
      }
    };

    switch (options.type) {

      case 'info': this.toastyService.info(toastOptions); break;
      case 'success': this.toastyService.success(toastOptions); break;
      case 'wait': this.toastyService.wait(toastOptions); break;
      case 'error': this.toastyService.error(toastOptions); break;
      case 'warning': this.toastyService.warning(toastOptions); break;
      default: this.toastyService.default(toastOptions); break;
    }
  }

}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/utils/notifications.service.ts